<template lang="pug">
.stepup
  app-header.header

  //- パンくずリスト
  ul.breadcrumb
    li
      router-link(to="/") {{ $t('Home') }}
    li
      router-link(to="/service_question") {{ $t('Service Questions') }}
    li(v-if="searchYear && searchMonth")
      router-link(:to="`/service_question/shop_results?year=${searchYear}&month=${searchMonth}`") 店舗別接遇評価結果一覧
    li.active
      span {{ $t('Service Questions Result List') }}

  .row.margin-top
    .col-sm-12
      //form
      div
        .form-inline(v-if="searchCallbackFlag")
          select.form-control(v-model="searchYear")
            option(:value="undefined") 年
            template(v-for="year in selectYears")
              option(:value="year") {{year}}年
          select.form-control(v-model="searchMonth")
            option(:value="undefined") 月
            template(v-for="i in 12")
              option(:value="i" :key="i + '月'") {{ i }}月
          select.form-control(v-model="searchShop" :disabled="isShopSelectDisabled")
            option(:value="undefined")
            template(v-for="shop in shops")
              option(:value="shop.id") {{shop.attributes['shop-name']}}
          button.btn.btn-info.margin-left(v-on:click="search(false)")
            i.fa.fa-search
            span 検索
          button.btn.btn-success.margin-left(v-on:click="goListDownload()" :disabled="!(searchYear&&searchMonth)" v-if="isHumanStaff")
            i.fa.fa-download
            span 一覧出力
          button.btn.btn-success.margin-left(v-on:click="goShopDetailDownload()" :disabled="!(searchShop&&searchYear&&searchMonth)" v-if="isHumanStaff")
            i.fa.fa-download
            span 評価詳細一覧出力
          button.btn.btn-success.margin-left(v-on:click="goDataDownload()" :disabled="!(searchShop&&searchYear&&searchMonth)" v-if="isHumanStaff")
            i.fa.fa-download
            span 評価シート出力

  div
    div(v-if="searchEnd && answers.length > 0")
      .row.margin-top
        //- 一覧表示
        .table-responsive
          table.table.table-condensed()
            //- 表示ヘッダ
            thead
              tr.info
                th.col-sm-2 店舗名
                th.col-sm-2 役職
                th.col-sm-2 評価対象者
                th.col-sm-2 評価日
                th.col-sm-3 評価タイトル
                th.col-sm-2(colspan=2) 総合評価
            tbody
              tr(v-for="answer in answers")
                td
                  span {{answer['shop_name']}}
                td
                  span {{answer['user_type_name']}}
                td
                  span {{answer['user_name']}} {{answer['user_firstname']}}
                td
                  span {{answer['answer_start_date']}}
                td
                  span {{answer['title']}}
                td
                  span {{answer['point']}}
                td(style="text-align: right;")
                  a(v-on:click="goto(answer['service_question_id'], answer['target_user_id'], answer['answer_start_date'])").btn.btn-success.btn-sm 詳細

      //- 更に読み込む
      .row.margin-top(v-if="nextExist")
        .col-xs-12.text-center
          button.btn.btn-default.next-page-search-btn(v-on:click="search(true)")
            i.fa.fa-chevron-down
            =" "
            span {{ $t('Read More') }}

    .row.margin-top(v-if="searchEnd && answers.length == 0")
      .col-xs-12
        .alert.alert-warning
          i.fa.fa-exclamation-triangle
          =" "
          span {{ $t('No Data') }}

</template>
<script>
var utils = require('../utils')
import AppHeader from './AppHeader'

export default {
  name: 'service-question',
  components: {
    AppHeader
  },
  data () {
    return {
      answers: [],
      searchShop: '',
      searchEnd: false,
      nextExist: false,
      currentPage: 0,
      searchYear: undefined,
      searchMonth: undefined,
      searchCallbackFlag: false
    }
  },
  computed: {
    isSystemManagement () {
      return this.$store.getters.isSystemManagement
    },
    isShopMaster () {
      return localStorage.is_shop_master === '1'
    },
    isHumanStaff () {
      return window.localStorage.getItem('is_human_staff') === '1'
    },
    localShopId () {
      return window.localStorage.getItem('shop_id')
    },
    selectYears () {
      let ret = []
      let startYear = 2019
      let today = new Date()
      let year = today.getFullYear()
      for (var i = startYear; i <= year; i++) {
        ret.push(i)
      }
      return ret
    },
    shops () {
      return this.$store.getters.shopsAll
    },
    isShopSelectDisabled () {
      return !this.isSystemManagement && !this.isHumanStaff
    }
  },
  created () {
    this.getShop()
    if (this.isHumanStaff || this.isSystemManagement) {
      this.searchShop = this.$store.getters.serviceQuestionSearchShopId
    } else {
      this.searchShop = this.localShopId
    }
    this.searchYear = this.$store.getters.serviceQuestionSearchYear
    this.searchMonth = this.$store.getters.serviceQuestionSearchMonth

    if (this.$route.query.shop_id) {
      this.searchShop = this.$route.query.shop_id
    }
    if (this.$route.query.year) {
      this.searchYear = parseInt(this.$route.query.year)
    }
    if (this.$route.query.month) {
      this.searchMonth = parseInt(this.$route.query.month)
    }

    if (!this.isSystemManagement && !this.isHumanStaff && this.isShopMaster) {
      if (this.$route.query.shop_id && parseInt(this.$route.query.shop_id) !== parseInt(this.localShopId)) {
        this.$router.push({ path: '/service_question/results', query: { shop_id: this.localShopId, year: this.$route.query.year, month: this.$route.query.month } })
        return
      }
    }

    this.search(false)
    // 最下部スクロール検索イベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove() // 最下部スクロール検索イベント削除
    next()
  },
  methods: {
    async search (addSearch) {
      let data = {
        shop_id: this.searchShop,
        year: this.searchYear,
        month: this.searchMonth
      }
      if (addSearch) {
        this.currentPage += 1
        data['current_page'] = this.currentPage
        data['add_search'] = true
      } else {
        this.searchEnd = false
        this.currentPage = 0
      }

      let res = await this.$store.dispatch('GET_SERVICE_RESULT_LIST', { data: data })
      .catch(err => {
        console.log(err)
        return
      })

      if (addSearch) {
        this.answers = this.answers.concat(res.answers)
      } else {
        this.answers = res.answers
        this.searchEnd = true
      }
      this.nextExist = res.next_exist
    },
    getShop: function () {
      const self = this
      const callback = function () {
        self.searchCallbackFlag = true
        // 退職者一覧店舗を表示しない
        let workIndex = 0
        for (let i = 0; i < self.shops.length; i++) {
          if (self.shops[i].id === '800') {
            workIndex = i
            break
          }
        }
        if (workIndex !== 0) {
          self.shops.splice(workIndex, 1)
        }
      }

      this.$store.dispatch('SHOP_ALL_GET', {callback: callback})
    },
    goto (serviceQuestionId, targetUserId, answerStartDate) {
      this.$router.push(`/service_question/results/${serviceQuestionId}/${targetUserId}/${answerStartDate}`)
    },
    async goDataDownload () {
      let data = {
        target_shop_id: this.searchShop,
        answer_start_year: this.searchYear,
        answer_start_month: this.searchMonth
      }
      let res = await this.$store.dispatch('DOWNLOAD_SERVICE_RESULT_DETAIL', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      window.open(res.url)
      data = {
        file_name: res.file_name
      }
      window.setTimeout(async function () {
        await this.$store.dispatch('DELETE_SERVICE_RESULT_DETAIL', { data: data })
      }, 3000)
    },
    async goListDownload () {
      let data = {
        target_shop_id: this.searchShop,
        answer_start_year: this.searchYear,
        answer_start_month: this.searchMonth
      }
      let res = await this.$store.dispatch('DOWNLOAD_SERVICE_RESULT_LIST', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      window.open(res.url)
      data = {
        file_name: res.file_name
      }
      await this.$store.dispatch('DELETE_SERVICE_RESULT_LIST', { data: data })
    },
    async goShopDetailDownload () {
      let data = {
        shop_id: this.searchShop,
        answer_start_year: this.searchYear,
        answer_start_month: this.searchMonth
      }
      let res = await this.$store.dispatch('DOWNLOAD_SHOP_SERVICE_DETAIL_DOWNLOAD', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      window.open(res.url)
      data = {
        file_name: res.file_name
      }
      window.setTimeout(async function () {
        await this.$store.dispatch('DELETE_SHOP_SERVICE_DETAIL_DOWNLOAD', { data: data })
      }, 3000)
    }
  }
}

</script>



// WEBPACK FOOTER //
// ServiceQuestionResultList.vue?0c230cb8